import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserType } from '../model/common.enum.model';
import { PhoneType, PortalSiteInfo } from '../model/services.model';
import { HttpHandlerService } from './http-handler.service';
import { UrlMapService } from './url-map.service';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  agentNumber!: number;
  isXcelerateRedirect = false;
  xceleratActionType: any;
  delegateTokenInfo: any;
  isDelegateLoggedIn:boolean = false;
  userRoleObj: any;
  agentSearchEmitter = new EventEmitter();
  xcelerateUserEmitter = new EventEmitter();
  employeeSearchEmitter = new EventEmitter();
  userInfo: any;
  searchedAgentInfo: any;
  fmUser = new BehaviorSubject<any>(null);
  showAgentView = new BehaviorSubject<any>(null);
  lastSearchAgentDetails: any;
  gotoHomeEvent = new BehaviorSubject<any>(null);
  changeCoreAssignment = new Subject<any>();
  updatedCoreAssignment: boolean = true;
  gotoHomeFromCoreModule = new Subject<any>();
  gotoPortalSearchFromCoreModule = new Subject<any>();
  gotoPortalManagerFromHome = new Subject<any>();
  gotoCoreServicesFromHome = new Subject<any>();
  officeManagerAgentSearchClick = false;
  manageClick = false;
  manageCoreClick = false;
  officeManagerAgentSearchClick$ = new Subject<any>();
  onRouteChangeConfirmEvent = new Subject<any>();
  redirectToNonEmployeeEdit = new Subject<any>();
  enablePortalClick = false;
  onlogoClick = false;
  refreshPhotoPageOfficeManage = new Subject<any>();
  updateCoreEmployeeSearch$ = new Subject<any>();
  editCurrentAssociation = new Subject<any>();
  currentAssociationDetail: any;
  getLatestTeamRole$ = new Subject<any>();
  officeListForOfficeWebsiteMenu: any;
  selectedOfficeListForOfficeWebsite$ = new Subject<any>();
  selectedOfficeListForOfficeWebsite: string = '';
  setTeamRole: string = '';
  clickHideNonEmployeeEvent: boolean = false;
  formUpdateStatus:boolean = false;
  isGoToCoreServiceFromPortal: boolean = false;
  isGoToPortalFromCore: boolean = false;
  isHomePage: boolean = false;
  delegateResponsiveFlag: boolean = true;
  agentTeamList: any;
  agentTeamCountObj: any;
  updateTeamCountObj$ = new Subject<any>();
  redirectToNewPage$ = new Subject<any>();
  delegateUserFlow = new Subject<any>();
  sessionTimerSubject$ = new Subject<any>();
  delegateUserInfo : any; 
  isPopState: boolean = false;
  initializeAdminSearchForm$ = new Subject<any>();
  initializeAdminSearchFormWithSelectedAgent$ = new Subject<any>();
  responsiveAdminSearchClicked: boolean = false;
  coreEmployeeSearchIconClicked: boolean = false;
  constructor(private http: HttpHandlerService, private urlMapService: UrlMapService,
    private httpClient: HttpClient) {
    // Do nothing
  }

  /**
   * Fetches user info
   * @param user 
   */
  getUserInfo(user: any): Observable<any> {
    let url  = '';
    if(this.getIsDelegateLoggedIn()) {      
      if(user?.Agent_Number !== ''){
        url = this.urlMapService.getUserDelegateUrl();
        return this.http.get(url + user?.Agent_Number);
      }
      else {
        url = this.urlMapService.getUserDelegateByEmailUrl();
        return this.http.get(url + user?.Email_Address);
      }
    } else {
      url = this.urlMapService.getUserInfoUrl();
      return this.http.get(url + user.onPremisesDomainName?.split('.')[0] + '\\' + user.onPremisesSamAccountName);
    }
  }

  /** set user info  */
  setUserInfo(user: any) {
    this.userInfo = user;
  }

  /** get logged in user info  */
  getSavedUserInfo() {
    return this.userInfo;
  }


  isAgentUser(): boolean {
    return UserType.Agent === this.userRoleObj?.siteUserType;
  }

  isSuperAdminUser(): boolean {
    return UserType.SuperAdmin === this.userRoleObj?.siteUserType;
  }

  isBranchAdminUser(): boolean {
    return UserType.BranchAdmin === this.userRoleObj?.siteUserType;
  }

  isOfficeManagerUser(): boolean {
    return UserType.OfficeManager === this.userRoleObj?.siteUserType;
  }

  isDeleGateUser(): boolean {
    return UserType.Delegate === this.userRoleObj?.siteUserType;
  }

  isSearchedOfficeManagerUser(obj: any): boolean {
    return UserType.OfficeManager === obj?.siteUserType;
  }

  isLOBUser(): boolean {
    return UserType.LOBUser === this.userRoleObj?.siteUserType;
  }

  /** get portal site details */
  getPortalSiteDetail(agentNumber: number): Observable<PortalSiteInfo> {
    const url = environment.base_url + "/v1/common/portal-site-details/agents/" + agentNumber;
    return this.httpClient.get<PortalSiteInfo>(url);
  }

  /** set agent number */
  setAgentNumber(agentNumber: number) {
    this.agentNumber = agentNumber;
  }

  /** get agent number */
  getAgentNumber() {
    return this.agentNumber
  }

   /** set delegate responsive number */
   setDelegateResponsiveFlag(flag: boolean) {
    this.delegateResponsiveFlag = flag;
  }

  /** get delegate responsive number */
  getDelegateResponsiveFlag() {
    return this.delegateResponsiveFlag;
  }

  /** set userRoleObj */
  setUserRoleObj(userRoleObj: number) {
    this.userRoleObj = userRoleObj;
  }

  /** get userRoleObj */
  getUserRoleObjr() {
    return this.userRoleObj;
  }

  /* Agent Search in Responsive view */
  searchAgentEmitter() {
    this.agentSearchEmitter.emit(null);
  }

   /* employee Search in Responsive view */
   searchEmployeeEmitter() {
    this.employeeSearchEmitter.emit(null);
  }

  /** download file QR code */
  downloadFileQRCOde(filename: string) {
    let dataurl = document.querySelectorAll("canvas");
    let a: any = document.createElement("a"); //Create <a>
    a.href = dataurl[1]?.toDataURL(); //Image Base64 Goes here
    a.download = filename; //File name Here
    a.click();
  }

  /** get portal site details */
  getOfficeNumer(agentdetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/office/" + agentdetails;
    const opts = { observe: 'response' };
    return this.http.get(url, opts);
  }

  /** get coreservice office  details */
  getcoreServiceOfficeNumer(agentdetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/SalesOffice/" + agentdetails;
    const opts = { observe: 'response' };
    return this.http.get(url, opts);
  }

  /** get portal site details */
  getAgentListbasedOnOffice(officeDetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/Agent/" + officeDetails;
    return this.httpClient.get<any>(url);
  }

  /** returns true if the  */
  isMobileDevice(): boolean {
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || Math.min(screen.width, window.innerWidth) <= 992;
    return isMobileDevice;
  }

  /** get search basic agent details*/
  getBasicSearchAgent(agent: number): Observable<any> {
    const url = environment.base_url + `/v1/personal-info/agents/${agent}/agent-info`;
    return this.httpClient.get<any>(url);
  }

  /** set basic information for searched agent */
  setSearchedAgentInfo(info: any) {
    this.searchedAgentInfo = info;
  }

  /** get basic information for searched agent */
  getSearchedAgentInfo() {
    return this.searchedAgentInfo;
  }

  public subscribeToFMUser(callback: (user: any) => void): Subscription {
    return this.fmUser.subscribe(callback);
  }

  public subscribeToAgentView(callback: (user: any) => void): Subscription {
    return this.showAgentView.subscribe(callback);
  }

  /** custorm Sort */
  customSort(data: any, eve: any) {
    let selected = data.filter((x: any) => x.subscriptionStatusId === 'Selected' && x.expirationDate !== null);
    let selecedWithNullDate = data.filter((x: any) => x.subscriptionStatusId === 'Selected' && x.expirationDate === null);
    let expired = data.filter((x: any) => x.subscriptionStatusId === 'Expiring' && x.expirationDate !== null);
    let notSelected = data.filter((x: any) => x.subscriptionStatusId === 'NotSelected');
    if (eve.value.name === 'Selected') {
      let arr = [...selected, ...selecedWithNullDate, ...expired, ...notSelected];
      return arr;
    } else if (eve.value.name === 'Not Selected') {
      let arr = [...notSelected, ...expired, ...selected, ...selecedWithNullDate];
      return arr;
    } else {
      return data;
    }
  }

  /** set last seacrh agent */
  setLastAgentSearchDetails(details: any) {
    this.lastSearchAgentDetails = details;
  }

  /** get last search agent */
  getLastSearchAgentDetails() {
    return this.lastSearchAgentDetails;
  }

  public subscribeToGoHome(callback: (user: any) => void): Subscription {
    return this.gotoHomeEvent.subscribe(callback);
  }

  /** to get the updated value on navidgating from current assignments to edit non employee page */
  public subscribeChangeCoreAssignment(callback: (user: any) => void): Subscription {
    return this.changeCoreAssignment.subscribe(callback);
  }

  /** get updated core assignment value */
  getchangeCoreAssignment() {
    return this.updatedCoreAssignment;
  }

  /** set updated core assignment value */
  setchangeCoreAssignment(value: boolean) {
    this.updatedCoreAssignment = value;
  }

  public subscribeToGoHomeFromCoreModule(callback: (user: any) => void): Subscription {
    return this.gotoHomeFromCoreModule.subscribe(callback);
  }

  public subscribeToGoPortalSearchFromCoreModule(callback: (user: any) => void): Subscription {
    return this.gotoPortalSearchFromCoreModule.subscribe(callback);
  }

  public subscribeToGoCoreServicesFromHome(callback: (user: any) => void): Subscription {
    return this.gotoCoreServicesFromHome.subscribe(callback);
  }

  public subscribeToRedirectToNonEmployeeEdit(callback: (user: any) => void): Subscription {
    return this.redirectToNonEmployeeEdit.subscribe(callback);
  }



  setOfficeManagerAgentSitesClick(flag: any) {
    sessionStorage.setItem('officeManagerAgentSearch', flag.toString());
    this.officeManagerAgentSearchClick = flag
  }

  getOfficeManagerAgentSitesClick() {
    return this.officeManagerAgentSearchClick;
  }

  public subscribeToOfficeManagerAgentSearch(callback: (user: any) => void): Subscription {
    return this.officeManagerAgentSearchClick$.subscribe(callback);
  }

  public subscribeOnRouteChangeConfirmEvent(callback: (user: any) => void): Subscription {
    return this.onRouteChangeConfirmEvent.subscribe(callback);
  }

  public subscribeRefreshPhotoPageOfficeManage(callback: (user: any) => void): Subscription {
    return this.refreshPhotoPageOfficeManage.subscribe(callback);
  }

  public subscribeUpdateCoreEmployeeSearch(callback: (user: any) => void): Subscription {
    return this.updateCoreEmployeeSearch$.subscribe(callback);
  }

  setOnManageClick(flag: any) {
    this.manageClick = flag
  }

  getOnManageClick() {
    return this.manageClick;
  }

  setOnCoreManageClick(flag: any) {
    this.manageCoreClick = flag
  }

  getOnCoreManageClick() {
    return this.manageCoreClick;
  }

  setEnablePortalClick(flag: any) {
    this.enablePortalClick = flag
  }

  getEnablePortalClick() {
    return this.enablePortalClick;
  }

  /** get portal site details */
  getJobTitleList(userDetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/JobTitle/" + userDetails;
    return this.httpClient.get<any>(url);
  }

  /** get portal site details */
  getCompanyList(userDetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/Company/" + userDetails;
    return this.httpClient.get<any>(url);
  }

  /** set on logo click event */
  setOnlogoClick(flag: boolean) {
    this.onlogoClick = flag;
  }

  /** set on logo click event */
  getOnlogoClick() {
   return this.onlogoClick;
  }

  /** get portal site details */
  getCoreServiceList(userDetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/CoreServiceType/" + userDetails;
    return this.httpClient.get<any>(url);
  }

  /** get region list */
  getRegionList(userDetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/Region/" + userDetails;
    return this.httpClient.get<any>(url);
  }

  /** get state list */
  getStateList(userDetails: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/State/" + userDetails;
    return this.httpClient.get<any>(url);
  }

  /** get office details */
  getOfficeList(officeEmail: string): Observable<any> {
  const url = environment.base_url + "/v1/common/lookup/types/Office/" + 'username=' + officeEmail;
  return this.httpClient.get<any>(url);
  }

  /** get office details */
  getOfficeListforOfficeShowcase(officeEmail: string): Observable<any> {
  const url = environment.base_url + "/v1/common/lookup/types/ManagerOffice/" + 'agentNumber=' + officeEmail;
  return this.httpClient.get<any>(url);
  }

  /** get timer options  details */
  getOfficeShowcaseTimer(): Observable<any> {
    const value = ' '
    const url = environment.base_url + "/v1/common/lookup/types/SlideShowTimer/" + value;
    const opts = { observe: 'response' };
    return this.http.get(url, opts);
  }

  /** get selected association details on edit */
  public subscribeToCurrentAssociationSelected(callback: (user: any) => void): Subscription {
    return this.editCurrentAssociation.subscribe(callback);
  }

  /** get latest team role of logged and searched user */
  public subscribeToGetTeamRole(callback: (user: any) => void): Subscription {
    return this.getLatestTeamRole$.subscribe(callback);
  }

  /** get selected Office List For Office Website Menu */
  public subscribeSelectedOfficeWebsite(callback: (user: any) => void): Subscription {
    return this.selectedOfficeListForOfficeWebsite$.subscribe(callback);
  }

  /** set current association detail on edit */
  setCurrentAssociationDetails(detail: any) {
    this.currentAssociationDetail = detail;
  }

  /** get current association detail on edit */
  getCurrentAssociationDetails() {
    return this.currentAssociationDetail;
  }

  /** get office dropdown values for office website menu */
  getOfficeListForOfficeWebsite(value: string): Observable<any> {
    const url = environment.base_url + "/v1/common/lookup/types/ManagerOffice/" + value;
    const opts = { observe: 'response' };
    return this.http.get(url, opts);
  }

  getterOfficeListOfficeWebsite() {
    return this.officeListForOfficeWebsiteMenu;
  }

  setOfficeListOfficeWebsite(arr: any) {
    arr.sort((item1: any, item2: any) => (item1.id - item2.id));
    this.officeListForOfficeWebsiteMenu = arr;
  }

  getterSelectedOfficeWebsite() {
    return this.selectedOfficeListForOfficeWebsite;
  }

  setterSelectedOfficeWebsite(value: string) {
    this.selectedOfficeListForOfficeWebsite = value;
  }

  /** get phone type details */
  getPhoneTypesList(agentNumber: string): Observable<PhoneType> {
    const url = environment.base_url + "/v1/common/lookup/types/PhoneTypes/agentNumber=" + agentNumber;
    return this.httpClient.get<PhoneType>(url);
  }

  setUserTeamRole(role: string) {
    this.setTeamRole = role;
  }

  getUserTeamRole() {
    return this.setTeamRole;
  }

  setClickNonEmployeeEvent(flag: boolean) {
    this.clickHideNonEmployeeEvent = flag;
  }

  getClickNonEmployeeEvent() {
    return this.clickHideNonEmployeeEvent;
  }

  
  setFormUpdateStatus(flag: boolean) {
    this.formUpdateStatus = flag;
  }

  getFormUpdateStatus() {
    return this.formUpdateStatus;
  }

  
  goToCoreServiceFromPortal(flag: boolean) {
    this.isGoToCoreServiceFromPortal = flag;
  }

  getGotoCoreServiceFromPortal() {
    return this.isGoToCoreServiceFromPortal;
  }

  
  goToPortalFromCore(flag: boolean) {
    this.isGoToPortalFromCore = flag;
  }

  getPortalFromCore() {
    return this.isGoToPortalFromCore;
  }

  /** get phone type details */
  getMobileServiceCarrier(agentNumber: string): Observable<PhoneType[]> {
    const url = environment.base_url + "/v1/common/lookup/types/MobileServiceCarrier/agentNumber=" + agentNumber;
    return this.httpClient.get<PhoneType[]>(url);
  }

  /** get team list api methdo */
  getTeamList(agent: number) {
    const url = `${environment.base_url}/v1/team/${agent}/team-names`;
    return this.httpClient.get<any>(url);
  }

  setTeamListDetails(list: any) {
    this.agentTeamList = list;
  }

  getTeamListDetails() {
    return this.agentTeamList;
  }

  setTeamCountObj(obj: any) {
    this.agentTeamCountObj = obj;
  }

  getTeamCountObj() {
    return this.agentTeamCountObj;
  }

  updateTeamCount() {
    this.updateTeamCountObj$.next(true);
  }

  public subscribeUpdateTeamCount(callback: (user: any) => void): Subscription {
    return this.updateTeamCountObj$.subscribe(callback);
  }

  redirectToNewPage(url: string) {
    this.redirectToNewPage$.next(url);
  }

  public subscribeRedirectToNewPage(callback: (user: any) => void): Subscription {
    return this.redirectToNewPage$.subscribe(callback);
  }
  setIsXcelerateRedirect(flag: boolean, action: number) {
    this.isXcelerateRedirect = flag;
    if(this.isXcelerateRedirect) {
      this.xcelerateUserEmitter.emit(true)
    }
    this.xceleratActionType = action;
  }

  getIsXcelerateRedirect() {
    return this.isXcelerateRedirect;
  }

  getXceleratActionType() {
    return this.xceleratActionType;
  }

  setDelegateTokenInfo(info: any) {
    this.delegateTokenInfo = info;
  }

  getDelegateTokenInfo() {
    return this.delegateTokenInfo;
  }

  setIsDelegateLoggedIn(flag: boolean) {
    this.isDelegateLoggedIn = flag;
  }

  getIsDelegateLoggedIn() {
    return this.isDelegateLoggedIn;
  }

  setDelegateUserInfo(obj: any) {
    this.delegateUserInfo = obj;
  }

  getDelegateUserInfo() {
    return this.delegateUserInfo;
  }

  /** Delegate office/agent list */
  getDelegateOfficeAgents(userName: any): Observable<any>{
    const url = this.urlMapService.getDelegateAgentsUrl() + userName;
    return this.httpClient.get<any>(url);
  }

  startSessionTimer(){
    this.sessionTimerSubject$.next(true);
  }

  public subscribeSessionTimer(callback: (user: any) => void): Subscription {
    return this.sessionTimerSubject$.subscribe(callback);
  } 

  setPopState(flag: boolean) {
    this.isPopState = flag;
  }

  getPopState() {
    return this.isPopState;
  }

  setHomePageFlag(flag: boolean) {
    this.isHomePage = flag;
  }

  getHomePageFlag() {
    return this.isHomePage;
  }

  initAdminSearchForm(){
    this.initializeAdminSearchForm$.next(true);
  }

  public subscribeInitAdminSearchForm(callback: (user: any) => void): Subscription {
    return this.initializeAdminSearchForm$.subscribe(callback);
  }
}
